export default __webpack_public_path__ + "static/media/channels.b4935a5a.svg";